import { IAccountMappingTemplateGroup } from '@modeso/types__aumico-lib-annualreport-be';
import { ITranslatorVisitor } from '../ITranslatorVisitor.interface';

export class Template {
    constructor(public group: IAccountMappingTemplateGroup) {}

    public accept(visitor: ITranslatorVisitor) {
        visitor.visit(this);
    }
}
